<template>
  <div class="dataList">
    <el-form ref="form" label-width="70px" style="width:100%;">
      <div class="title">
        <img src="@/assets/img/14.png" alt />
        <span>筛选条件</span>
      </div>
      <el-form-item class="labelStyle" style="margin:20px;position:relative;">
        <span slot="label" style="font-weight: bold;color: #DFECF7;">选择股票</span>
        <el-input v-model="search.choosedItems" style="width:35%;" readonly></el-input>
        <span
          @click="chooseUpMarket"
          style=" display: inline-block;text-align: center;margin-left: 10px;background:#023261;width: 98px;height: 40px;color: rgb(60, 152, 245);border-radius: 2px;"
        >选择</span>

        <!-- 股票弹出框 -->
        <el-card
          class="box-card_one"
          style="position: absolute;top:44px;left:0;height:464px;width:78%;z-index: 10000;display: none;"
        >
          <div
            class="ticket_alert_box"
            style="width:98%;height:368px;margin:0 auto;overflow:hidden;"
          >
            <div
              class="ticket_alert_l_one"
              style="width:30%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;"
            >
              <el-form-item label="股票搜索" style="margin-top:16px;font-weight: bold;">
                <el-input
                  id="searchOne"
                  @input="querySearch()"
                  @click.native="querySearch()"
                  v-model="search.state"
                  style="width:100%; "
                  size="small"
                  suffix-icon="el-icon-search"
                ></el-input>
              </el-form-item>
              <div
                class="ticket_alert_l_one_ztree"
                style="width:99%;height:297px;border:1px solid #dfdfdf;margin-top:10px;border-radius: 4px;overflow:scroll;"
              >
                <!-- 树形图 -->
                <div style="margin:10px;width:120%;height:100%;position: relative;">
                  <el-tree
                    ref="tree"
                    :data="search.treeeData"
                    :indent="16"
                    show-checkbox
                    node-key="lable"
                    :props="search.defaultProps"
                    @check="handleNodeClick"
                    style="width:100%;height:100%;"
                  ></el-tree>
                  <!-- <elTree2
                                                ref="tree" 
                                                :data="search.treeeData" 
                                                :indent="16" 
                                                show-checkbox 
                                                :props="search.defaultProps" 
                                                @check="handleNodeClick" 
                                                style="width:100%;height:100%;">
                  </elTree2>-->
                  <!-- <span style="width:16px;height:10000px;background:#fff;position: absolute;top:0;left:23px;z-index: 10000;"></span> -->
                </div>
              </div>
            </div>
            <div
              class="ticket_alert_l_two"
              style="width:30%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;"
            >
              <el-form-item style="overflow: hidden;margin-top:22px;">
                <span
                  style="font-weight:bold;color:rgb(96, 98, 102);"
                >可选股票[{{search.canSelect.length}}]个</span>
                <el-checkbox
                  :indeterminate="search.isIndeterminate"
                  v-model="search.checkAll"
                  @change="handleCheckAllChange"
                  style="float:right;"
                >全选</el-checkbox>
              </el-form-item>
              <div
                style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
              >
                <el-checkbox-group
                  v-model="search.checkedCities"
                  @change="handleCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="item in search.canSelect"
                    :label="item.stockName"
                    :key="item.enterpriseCode"
                    style="width:90%;margin:0 auto;display: block;"
                  >{{item.stockName}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div
              class="ticket_alert_l_three"
              style="width:30%;height:100%;display: inline-block;overflow:hidden;float:left;"
            >
              <el-form-item style="overflow: hidden;margin-top:22px;">
                <span
                  style="font-weight:bold;color:rgb(96, 98, 102);"
                >已选股票[{{search.checkedCities.length}}]个</span>
                <span
                  @click="removeClickedUpMarketFn"
                  style="float: right;color:#ef3938;cursor: pointer;"
                >全部删除</span>
              </el-form-item>
              <div
                style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
              >
                <ul style="padding:2px 10px;">
                  <li
                    v-for="(v,i) in search.checkedCities"
                    @click="removeOneSelectedUpMarketFn(v)"
                    style="width:100%;white-space: nowrap;cursor: pointer;"
                    :key="i"
                  >
                    <img
                      src="../assets/upmarket/remove.png"
                      alt
                      style="display: inline-block;height: 13px;margin-right: 4px;"
                    />
                    <span
                      style="font-size: 14px;display: inline-block;line-height: 1;width:90%;"
                    >{{v}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="search_upmarket_btn"
            @click="searchUpmarketBtn"
            style="background:#3584ed;color:#fff;width:80px;height:30px;text-align: center;line-height: 30px;border-radius: 2px;float:right;margin-right: 2.2%;margin-top:20px;cursor: pointer;"
          >确定</div>
        </el-card>
        <!-- <el-button>股票导入</el-button> -->
        <el-upload
          class="upload-demo"
          style="display: inline-block;"
          ref="upload"
          :action="search.uploadUrl"
          :show-file-list="false"
          :on-success="successUpload"
          :file-list="search.fileList"
          :auto-upload="true"
          accept=".txt"
          :limit="1"
        >
          <div
            style="background: #023261;width:98px;height:40px;color:#3C98F5;border-radius:2px;"
          >股票导入</div>
        </el-upload>
        <span
          @click="downloadFiles"
          style="border:none;color:#3C98F5;margin-left:0;padding:12px 10px;cursor: pointer;"
        >文件模板</span>
      </el-form-item>
      <el-form-item style="margin:20px;">
        <span slot="label" style="font-weight: bold;color: #DFECF7;">选择数据</span>
        <el-select
          @change="searchTextSelectFn"
          v-model="searchData.value"
          placeholder="请选择"
          style="width:35%;"
        >
          <el-option
            v-for="item in searchData.select"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span v-show="searchData.value != 0" style="margin-left:10px;color: #DFECF7;">选择报告期</span>
        <el-select
          @change="changeDateFn"
          v-show="searchData.value != 0"
          v-model="searchData.quarterValue"
          multiple
          collapse-tags
          :multiple-limit="5"
          placeholder="选择报告期"
          style="width:35%;margin-left: 10px;"
        >
          <el-option
            v-for="item in searchData.quarter"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin:20px;position:relative;">
        <span slot="label" style="font-weight: bold;color: #DFECF7;">选择字段</span>
        <el-input v-model="searchText.choosedItems" style="width:35%;" readonly></el-input>
        <div
          @click="chooseTextFn"
          style="display: inline-block;text-align: center;margin-left: 10px;background:#023261;width: 98px;height: 40px;color: rgb(60, 152, 245);border-radius: 2px;"
        >选择</div>
        <!-- 选择字段弹出框 -->
        <el-card
          class="box-card_two"
          style="position: absolute;top:44px;left:0;height:430px;width:48%;z-index: 10000;display: none;"
        >
          <div
            class="ticket_alert_box"
            style="width:98%;height:350px;margin:0 auto;overflow:hidden;"
          >
            <div
              class="ticket_alert_l_two"
              style="width:47%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;"
            >
              <el-form-item style="overflow: hidden;">
                <span style="font-weight:bold;">可选字段[{{searchText.canSelect.length}}]个</span>
                <el-checkbox
                  :indeterminate="searchText.isIndeterminate"
                  v-model="searchText.checkAll"
                  @change="handleCheckAllChange2"
                  style="float:right;"
                >全选</el-checkbox>
              </el-form-item>
              <div
                style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
              >
                <el-checkbox-group
                  v-model="searchText.checkedCities"
                  @change="handleCheckedCitiesChange2"
                >
                  <el-checkbox
                    v-for="item in searchText.canSelect"
                    :label="item.indicatorName"
                    :key="item.indicatorId"
                    style="width:90%;margin:0 auto;display: block;white-space: nowrap;"
                  >{{item.indicatorName}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div
              class="ticket_alert_l_three"
              style="width:47%;height:100%;display: inline-block;overflow:hidden;float:left;"
            >
              <el-form-item style="overflow: hidden;">
                <span style="font-weight:bold;">已选字段[{{searchText.checkedCities.length}}]个</span>
                <span
                  @click="removeClickedUpMarketFn2"
                  style="float: right;color:#ef3938;cursor: pointer;"
                >全部删除</span>
              </el-form-item>
              <div
                style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
              >
                <ul style="padding:2px 10px;">
                  <li
                    v-for="(v,i) in searchText.checkedCities"
                    @click="removeOneSelectedUpMarketFn2(v)"
                    style="width:100%;white-space: nowrap;cursor: pointer;"
                    :key="i"
                  >
                    <img
                      src="../assets/upmarket/remove.png"
                      alt
                      style="display: inline-block;height: 13px;margin-right: 4px;"
                    />
                    <span
                      style="font-size: 14px;display: inline-block;line-height: 1;width:90%;"
                    >{{v}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="search_upmarket_btn"
            @click="searchTextBtn"
            style="background:#3584ed;color:#fff;width:80px;height:30px;text-align: center;line-height: 30px;border-radius: 2px;float:right;margin-right: 2.2%;margin-top:12px;"
          >确定</div>
        </el-card>
        <el-button
          @click="searchAllBtnLogin(1)"
          type="primary"
          style="margin-left:20px;padding:12px 40px;"
        >查询</el-button>
      </el-form-item>
    </el-form>
    <div class="showTablesDiv" style="padding-top:20px;width:100%;">
      <div
        @click="downloadFn(0)"
        style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:0;margin-left:20px;margin-bottom:20px;margin-right:25px;"
      >
        <img
          src="@/assets/img/Excel.png"
          alt
          style="display: inline-block;height: 18px;width:18px;float:left;"
        />
        <span
          style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;"
        >下载数据到Excel</span>
      </div>
      <!-- :show-header="false" -->
      <el-table
        v-loading="graph.loading"
        :fit="true"
        size="mini"
        style="width:97%;margin:20px auto;"
        :data="graph.tableData"
        :header-cell-style="{'color': '#333333','font-weight':'bold','font-family':'Microsoft YaHei','background':'#F7F7F7'}"
        @row-click="cellClickFn"
        @sort-change="sortChangeFn"
        :cell-style="cellStyle"
        border
      >
        <!-- tableOrderData -->
        <el-table-column
          v-for="(item,index) in graph.tableData[0]"
          :key="index"
          :prop="index"
          :label="item"
          :show-overflow-tooltip="true"
          :sortable="isInArray(graph.tableOrderData,item) ? 'custom' : false"
          align="center"
          :fixed="(index == 0 || index == 1) ? true : false "
          :width="graph.tableColumnWidth[index] < 24 ? graph.tableColumnWidth[index] * 16 : (graph.tableColumnWidth[index] * 8)"
        >
          <!-- :width="(graph.tableData[1][index] == null || graph.tableData[1][index] == '' || Number(graph.tableData[1][index])) ? graph.tableData[0][index].length * 27 : (graph.tableData[1][index].length <4 ? graph.tableData[1][index].length * 85 : (graph.tableData[1][index].length > 100 ? graph.tableData[1][index].length * 16 :graph.tableData[1][index].length * 29))" -->
        </el-table-column>
      </el-table>
      <div style="width:100%;padding-bottom:20px;margin-left:20px;">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          :current-page="graph.currentPage"
          @current-change="handleCurrentChange"
          :page-size="graph.limit"
          layout="total, prev, pager, next, jumper"
          :total="graph.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import api from "../../static/common/api/api.js";
window.api = api;
import magic from "../../static/common/magic.js";
import axios from "axios";
export default {
  data() {
    return {
      //选择数据
      searchData: {
        select: [], //下拉框选项数据
        value: "",
        quarter: [], //季度下拉框数据
        quarterValue: ""
      },
      //选择字段
      searchText: {
        canSelect: [], //可选股票
        checkAll: false,
        checkedCities: [], //可选股票的默认选中
        isIndeterminate: false, //可选股票的默认选中
        choosedItems: "" //选中的字段
      },
      //股票搜索数据
      search: {
        state: "", //搜索输入框状态
        canSelect: [], //可选股票
        checkAll: false,
        checkedCities: [], //可选股票的默认选中
        isIndeterminate: false, //可选股票的默认选中
        treeeData: [], //股票搜索树形图数据
        defaultProps: {
          children: "children",
          label: "lable"
        },
        choosedTreeNode: [], //树形图选中项
        fileList: [], //上传文件列表
        uploadUrl: window.baseUrl + "/listCcompany/uploadFile",
        choosedItems: "" //选中的股票
      },
      graph: {
        count1: [], //上海证券交易所数据
        count2: [], //深圳证券交易所数据
        tabBool: true, //tab切换
        tableData: [],
        tableOrderData: [], //表格有排序的集合
        tableColumnWidth: [], //表格各个列最大宽度
        creditCodes: {}, //获取点击每一个股票的creditCodes信息
        offset: 0, //page
        limit: 15,
        total: 0,
        currentPage: 1,
        boolTable: false, //判断当前表格是全局渲染还是条件搜索渲染
        defaultTable: true, //判断当前是默认表格还是筛选表格
        orderByCode: "",
        orderNum: 1,
        loading: false //tableloading状态
      }
    };
  },
  methods: {
    //选择股票--按钮弹出事件--------搜索开始-----------------
    //下载函数
    downloadFn(incomeType) {
      let _this = this;
      //判断是否有权限，是否登录
      window.that = this;
      magic.loginOrRights(0).then(res => {
        if (!res) {
          _this.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          _this.$message.error("请您购买！");
          return;
        }

        let data = {};
        if (_this.graph.boolTable) {
          //条件搜索
          let str = "";
          let tmpArr = _this.searchText.choosedItems.split(",");

          for (let i = 0; i < _this.searchText.canSelect.length; i++) {
            for (let j = 0; j < tmpArr.length; j++) {
              if (tmpArr[j] == _this.searchText.canSelect[i].indicatorName) {
                str += _this.searchText.canSelect[i].indicatorCode + ",";
              }
            }
          }
          str = str.substring(0, str.length - 1);
          let timeStr = "";
          for (let i = 0; i < _this.searchData.quarterValue.length; i++) {
            timeStr += _this.searchData.quarterValue[i] + ",";
          }
          data = {
            stockCodes: _this.search.choosedItems, //股票代码
            reportDate: timeStr, //日期报告
            dataCode: _this.searchData.value, //数据编码
            indicatorCodes: str, //选择字段
            orderRule: 0, //排序规则 0:降序 1:升序
            orderByCode: "company_stock_code" //排序编码
          };
        } else {
          //全局加载
          data = {
            stockCodes: "", //股票代码
            reportDate: "", //日期报告
            dataCode: 0, //数据编码
            indicatorCodes: "", //选择字段
            orderRule: 0, //排序规则 0:降序 1:升序
            orderByCode: "company_stock_code" //排序编码
          };
        }
        _this.downloadTableFiles(
          window.baseUrl +
            "/listCcompany/downComparativeData?stockCodes=" +
            data.stockCodes +
            "&reportDate=" +
            data.reportDate +
            "&dataCode=" +
            data.dataCode +
            "&indicatorCodes=" +
            data.indicatorCodes +
            "&orderRule=" +
            data.orderRule +
            "&orderByCode=" +
            data.orderByCode
        );

        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
        } catch (e) {}
      });
    },
    downloadTableFiles(url) {
      console.log(url, "url");
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    changeDateFn(val) {
      // console.log(val,'test');
      if (val.length == 5) {
        this.$message({
          message: "您选的参数总数已达到上限！",
          type: "warning"
        });
      }
    },
    //表格点击排序
    sortChangeFn(column, prop, order) {
      console.log(column, prop, order, "sort");
      // 点击时先升序ascending,再点击降序descending
      let orderNum = column.order == "ascending" ? 1 : 0;
      let context = column.column.label;
      let orderByCode = "";
      let arr = this.graph.tableOrderData;
      for (let i = 0; i < arr.length; i++) {
        if (context === arr[i].name) {
          orderByCode = arr[i].code;
        }
      }
      console.log(orderByCode, "orderByCode");
      this.graph.orderByCode = orderByCode;
      this.graph.orderNum = orderNum;

      if (this.graph.defaultTable) {
        //
        this.searchAllBtn(1, 1); //加载默认表格数据
      } else {
        this.searchAllBtnLogin(0); //加载筛选数据
      }
    },
    //判断元素是否在数组里面
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i].name) {
          return true;
        }
      }
      return false;
    },
    //点击表格股票
    cellClickFn(row, column, event) {
      let _this = this;
      //判断是否有权限，是否登录
      window.that = this;
      magic.loginOrRights(0).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          that.$message.error("请您购买！");
          return;
        }
        let index = row.index;
        if (
          row[1] == event.target.innerText &&
          event.target.innerText != "股票名称"
        ) {
          if (Object.keys(_this.graph.creditCodes).length) {
            let tmpObj = this.graph.creditCodes;
            for (let item in tmpObj) {
              if (row[0] == item) {
                // let routeData = _this.$router.resolve({
                //   path: "/stock/2/baseinfo",
                //   query: { creditCode: tmpObj[item] }
                // });

                // window.open(routeData.href, "_blank");
                _this.$router.push({
                  path: "/stock/2/baseinfo",
                  query: { creditCode: tmpObj[item] }
                });
              }
            }
          }
        }
        if (
          row[0] == event.target.innerText &&
          event.target.innerText != "股票代码"
        ) {
          if (Object.keys(_this.graph.creditCodes).length) {
            let tmpObj = _this.graph.creditCodes;
            for (let item in tmpObj) {
              if (row[0] == item) {
                // let routeData = _this.$router.resolve({
                //   path: "/stock/2/baseinfo",
                //   query: { creditCode: tmpObj[item] }
                // });
                _this.$router.push({
                  path: "/stock/2/baseinfo",
                  query: { creditCode: tmpObj[item] }
                });
                // window.open(routeData.href, "_blank");
              }
            }
          }
        }
        if (
          row[4] == event.target.innerText &&
          event.target.innerText != "公司名称"
        ) {
          if (Object.keys(_this.graph.creditCodes).length) {
            let tmpObj = this.graph.creditCodes;
            for (let item in tmpObj) {
              if (row[0] == item) {
                // let routeData = _this.$router.resolve({
                //   path: "/enterprisesDetail",
                //   query: { creditCode: tmpObj[item] }
                // });
                _this.$router.push({
                  path: "/enterprisesDetail",
                  query: { entId: tmpObj[item] }
                });
                // window.open(routeData.href, "_blank");
              }
            }
          }
        }
      });
    },
    //table的单元格样式
    cellStyle(row, column, rowIndex, columnIndex) {
      //styles
      let _this = this;
      if (row.columnIndex == 4 && row.rowIndex > 0) {
        return "color:rgb(53, 131, 237);cursor: pointer;";
      }
      if (row.columnIndex == 1 && row.rowIndex > 0) {
        return "color:rgb(53, 131, 237);cursor: pointer;";
      }
      if (row.columnIndex == 0 && row.rowIndex > 0) {
        return "color:rgb(53, 131, 237);cursor: pointer;";
      }
      if (row.rowIndex == 0) {
        return "color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;";
      }
    },
    // 分页函数
    handleCurrentChange(val) {
      //当前页
      this.graph.currentPage = val;
      this.graph.offset = (val - 1) * this.graph.limit;
      this.graph.boolTable ? this.searchAllBtn(0, 0) : this.searchAllBtn(1, 0);
    },
    //下载文件
    downloadFiles() {
      this.download("@/../static/common/files/demo1.txt", "股票代码示例文件");
      setTimeout(() => {
        this.download("@/../static/common/files/demo2.txt", "示例说明");
      }, 300);
    },
    //文件下载
    download(url, filename) {
      return fetch(url).then(res =>
        res.blob().then(blob => {
          let a = document.createElement("a");
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        })
      );
    },
    //筛选查询按钮登录和权限判断
    searchAllBtnLogin(num) {
      //判断是否有权限，是否登录
      window.that = this;
      magic.loginOrRights(0).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          that.$message.error("请您购买！");
          return;
        }
        if (num == 1) {
          //当点查询按钮时
          that.graph.orderNum = 1; //排序规则 0:降序 1:升序
          that.graph.orderByCode = "company_stock_code"; //排序编码
          // 埋点
          try {
            //LogCollection.contents["key"]="value";
            //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
            //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
            LogCollection.send(9);
          } catch (e) {}
        }
        that.graph.loading = true; //添加loading
        that.graph.currentPage = 1;
        that.searchAllBtn(0, 1);
      });
    },
    //查询按钮触发函数
    searchAllBtn(_num = 0, initalPage = 0) {
      let _this = this;
      let str = "";
      let _data = {};
      this.graph.loading = true; //添加loading
      if (!_num) {
        //第一次加载不加这两个字段
        let tmpArr = _this.searchText.choosedItems.split(",");
        this.graph.boolTable = true;

        if (initalPage) {
          //判断是否初始化页码1为初始化，0为不初始化
          _this.graph.offset = 0;
          _this.graph.defaultTable = false;
        }

        if (!_this.search.choosedItems) {
          this.$message.error("请选择股票代码！");
          return;
        }
        if (!_this.searchText.choosedItems) {
          this.$message.error("请选择字段！");
          return;
        }
        for (let i = 0; i < _this.searchText.canSelect.length; i++) {
          for (let j = 0; j < tmpArr.length; j++) {
            if (tmpArr[j] == _this.searchText.canSelect[i].indicatorName) {
              str += _this.searchText.canSelect[i].indicatorCode + ",";
            }
          }
        }
        str = str.substring(0, str.length - 1);
        let timeStr = "";
        for (let i = 0; i < _this.searchData.quarterValue.length; i++) {
          timeStr += _this.searchData.quarterValue[i] + ",";
        }

        _data = {
          stockCodes: _this.search.choosedItems, //股票代码
          reportDate: timeStr, //日期报告
          dataCode: _this.searchData.value, //数据编码
          indicatorCodes: str, //选择字段
          orderRule: _this.graph.orderNum, //排序规则 0:降序 1:升序
          orderByCode: _this.graph.orderByCode
            ? _this.graph.orderByCode
            : "company_stock_code", //排序编码
          offset: _this.graph.offset, //多少条开始
          limit: _this.graph.limit //条数
        };
        _this.graph.tabBool = false; //点击查询，切换到表格
        $(".graphTab1").css("background", "#f4f4f4");
        $(".graphTab2").css("background", "#fff");
      } else {
        this.graph.boolTable = false; //给分页一个信号
        _data = {
          dataCode: 0,
          indicatorCodes: "",
          orderRule: _this.graph.orderNum,
          orderByCode: _this.graph.orderByCode
            ? _this.graph.orderByCode
            : "company_stock_code",
          offset: _this.graph.offset, //多少条开始
          limit: _this.graph.limit //条数
        };
      }
      // console.log(_data, "_data");
      // console.log(window.normalUrl)
      $.ajax({
        type: "POST",
        url: window.normalUrl + "/list/listCcompany/getComparativeData",
        // url: '/api' + "/list/listCcompany/getComparativeData",
        data: JSON.stringify(_data),
        dataType: "json",
        contentType: "application/json",
        success: function(data) {
          _this.graph.tableData = data.data.rows;
          _this.graph.tableOrderData = data.data.orderData;
          _this.graph.creditCodes = data.data.creditCodes;
          _this.graph.total = data.data.total;
          // console.log(data.data.rows, "data");
          _this.getMaxTableWidthFn(data.data.rows);
          setTimeout(() => {
            _this.graph.loading = false; //取消loading
          }, 1000);
        }
      });
    },
    //获取表格每一列的文字最大长度
    getMaxTableWidthFn(data) {
      let _this = this;
      let tmpLen = Object.keys(data[0]).length;
      let arr = [];
      for (let i = 0; i < tmpLen; i++) {
        arr.push([]);
      }
      for (let i = 0; i < data.length; i++) {
        for (let item in data[i]) {
          let len = _this.chkstrlen(String(data[i][item]));
          arr[item].push(len);
        }
      }
      _this.graph.tableColumnWidth = [];
      for (let i = 0; i < arr.length; i++) {
        _this.graph.tableColumnWidth.push(Math.max(...arr[i]));
      }
      // console.log(_this.graph.tableColumnWidth,'widthArr');
    },
    //判断是否是汉字
    chkstrlen(str) {
      let strlen = 0;
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255) {
          //如果是汉字，则字符串长度加2
          strlen += 2;
        } else {
          strlen++;
        }
      }
      return strlen;
    },
    //上传文件
    successUpload(response, file, fileList, $event) {
      let _this = this;
      if (response.message == "success" && response.data[0]) {
        if (response.data.length > 0) {
          for (let i = 0; i < response.data.length; i++) {
            let len = _this.search.checkedCities.length;
            _this.search.checkedCities.push(response.data[i].stockName);

            let newArr = Array.from(new Set(_this.search.checkedCities)); //去重

            if (newArr.length > len) {
              _this.search.choosedItems +=
                response.data[i].stockName.substring(0, 6) + ",";
            } else {
              _this.search.checkedCities = newArr;
            }
          }
        }
        this.$refs.upload.clearFiles(); //清空上传的文件
      }
    },
    //获取树形图数据
    fetchTreeData() {
      let _this = this;
      api.upmarketsearchTree().then(res => {
        let data = res.data;
        // console.log(data, "data11");
        // data[0].showCheckbox = false;
        _this.search.treeeData = data;
      });
    },
    //选择股票--树形图点击事件
    handleNodeClick(data, dataAll) {
      let _this = this;
      let data2 = dataAll.checkedNodes;
      let tmpArr = [];
      let str = "";
      for (let i = 0; i < data2.length; i++) {
        if (!data2[i].children) {
          tmpArr.push({
            classId: data2[i].classId,
            searchId: data2[i].searchId,
            lable: data2[i].lable
          });
          str += data2[i].searchId + ":" + data2[i].classId + ";";
        }
      }
      this.search.choosedTreeNode = tmpArr;
      api.upmarketsearchById(str).then(res => {
        let data = res.data;
        _this.search.canSelect = data;
      });
    },
    //打开股票选择弹框
    chooseUpMarket() {
      //判断是否有权限，是否登录
      this.graph.tabBool = false; //切换tab选项
      $(".graphTab1").css({ background: "#f4f4f4", color: "#67696B" });
      $(".graphTab2").css({ background: "#fff", color: "#3583ED" });
      window.that = this;
      magic.loginOrRights(0).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          that.$message.error("请您购买！");
          return;
        }
        let bools = $(".box-card_one").css("display");
        bools == "none"
          ? $(".box-card_one").css("display", "block")
          : $(".box-card_one").css("display", "none");
      });
    },
    //删除所有已选股票
    removeClickedUpMarketFn() {
      this.search.checkedCities = [];
      this.search.checkAll = false;
    },
    //删除所有已选字段
    removeClickedUpMarketFn2() {
      this.searchText.checkedCities = [];
      this.searchText.checkAll = false;
    },
    //删除单个已选股票
    removeOneSelectedUpMarketFn(item) {
      let data = this.search.checkedCities;
      Array.prototype.remove = function(val) {
        //删除数组里某一个元素
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      setTimeout(() => {
        this.search.checkedCities.remove(item);
      }, 300);
    },
    //删除单个已选字段
    removeOneSelectedUpMarketFn2(item) {
      let data = this.searchText.checkedCities;
      Array.prototype.remove = function(val) {
        //删除数组里某一个元素
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      setTimeout(() => {
        this.searchText.checkedCities.remove(item);
      }, 300);
    },
    //搜索股票输入框
    querySearch() {
      // e.stopPropagation();
      // e.preventDefault();
      let _this = this;
      this.$forceUpdate();
      if (!this.search.state) {
        return;
      }
      let searchName = this.search.state;
      api.upmarketsearchMarket(searchName).then(res => {
        let data = res.data;
        _this.search.canSelect = data;
        return false;
      });
    },
    //选择股票--确定按钮
    searchUpmarketBtn() {
      $(".box-card_one").css("display", "none");
      let str = "";
      let data = this.search.checkedCities;
      for (let i = 0; i < data.length; i++) {
        str += data[i].substring(0, 6) + ",";
      }
      this.search.choosedItems = str;
      this.search.state = "";
    },
    //在页面点击后关闭股票提示框
    bodyCloseAlert() {
      $(".home")
        .off("click")
        .on("click", e => {
          if ($(e.target).closest(".box-card_one").length == 0) {
            $(".box-card_one").css("display", "none");
          }

          if ($(e.target).closest(".box-card_two").length == 0) {
            $(".box-card_two").css("display", "none");
          }
        });
    },
    //选择股票--全选
    handleCheckAllChange(val) {
      let _this = this;
      if (val) {
        this.search.checkedCities = [];
        let select = this.search.canSelect;
        for (let i = 0; i < select.length; i++) {
          _this.search.checkedCities.push(select[i].stockName);
        }
      } else {
        this.search.checkedCities = [];
      }
      this.search.isIndeterminate = false;
    },
    //选择字段--全选
    handleCheckAllChange2(val) {
      let _this = this;
      if (val) {
        this.searchText.checkedCities = [];
        let select = this.searchText.canSelect;
        for (let i = 0; i < select.length; i++) {
          _this.searchText.checkedCities.push(select[i].indicatorName);
        }
      } else {
        this.searchText.checkedCities = [];
      }
      this.searchText.isIndeterminate = false;
    },
    //选择股票--每一个成员被选中后，全选按钮自动改变
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.search.checkAll = checkedCount === this.search.canSelect.length;
      this.search.isIndeterminate =
        checkedCount > 0 && checkedCount < this.search.canSelect.length;
    },
    //选择字段--每一个成员被选中后，全选按钮自动改变
    handleCheckedCitiesChange2(value) {
      let checkedCount = value.length;
      this.searchText.checkAll =
        checkedCount === this.searchText.canSelect.length;
      this.searchText.isIndeterminate =
        checkedCount > 0 && checkedCount < this.searchText.canSelect.length;
    },
    //选择字段--弹出按钮事件
    chooseTextFn() {
      // 判断是否有权限，是否登录
      this.graph.tabBool = false; //切换tab选项
      $(".graphTab1").css({ background: "#f4f4f4", color: "#67696B" });
      $(".graphTab2").css({ background: "#fff", color: "#3583ED" });
      window.that = this;
      magic.loginOrRights(0).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          that.$message.error("请您购买！");
          return;
        }
        let bools = $(".box-card_two").css("display");
        bools == "none"
          ? $(".box-card_two").css("display", "block")
          : $(".box-card_two").css("display", "none");
      });
    },
    //选择字段--下拉框数据获取
    searchTextFetchSelectFn() {
      let _this = this;
      api.upmarketsearchTextSelect().then(res => {
        let data = res.data;
        if (data.length == 0) {
          return;
        }
        for (let i = 0; i < data.length; i++) {
          _this.searchData.select.push({
            value: data[i].dataCode,
            label: data[i].dataName
          });
        }
        _this.searchData.value = data[0].dataCode; //默认选第一个
        _this.searchTextSelectFn(data[0].dataCode); //选择字段初始化第一个列表
      });
    },
    //选择字段--下拉框触发函数
    searchTextSelectFn(val) {
      let _this = this;
      api.upmarketsearchTextGetList(val).then(res => {
        let data = res.data;
        this.searchText.canSelect = [];
        this.searchText.checkedCities = [];
        this.searchText.choosedItems = "";
        this.searchText.checkAll = false;
        for (let i = 0; i < data.length; i++) {
          this.searchText.canSelect.push({
            indicatorName: data[i].indicatorName,
            indicatorId: data[i].indicatorId,
            indicatorCode: data[i].indicatorCode
          });
        }
      });
      if (val > 0) {
        this.searchData.quarter = [];
        this.searchData.quarterValue = "";
        api.upmarketsearchTextSelectTime(val).then(res => {
          let data = res.data;
          for (let i = 0; i < data.length; i++) {
            this.searchData.quarter.push({
              label: data[i].aliasName,
              value: data[i].reportDate
            });
          }
        });
      } else {
        this.searchData.quarter = [];
        this.searchData.quarterValue = "";
      }
    },
    //选择字段--确定按钮
    searchTextBtn() {
      $(".box-card_two").css("display", "none");
      let str = "";
      let data = this.searchText.checkedCities;
      for (let i = 0; i < data.length; i++) {
        str += data[i] + ",";
      }
      this.searchText.choosedItems = str;
    }
  },
  mounted() {
    this.fetchTreeData(); //股票搜索--树形图数据获取
    this.searchTextFetchSelectFn(); //选择字段--下拉框数据获取
    this.searchAllBtn(1, 1); //进入页面加载表格数据
    this.bodyCloseAlert(); //点击空白关闭股票弹出框
  }
};
</script>

<style scoped lang="less">
// @import "../assets/less/style.less";
// @import "../assets/less/right.less";
// @import "../assets/less/moreThanThree.less";
/deep/ .el-card__body {
  /deep/ .el-input__inner {
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #000;
  }
}
/deep/.el-table__header-wrapper {
  background: #052b4f;
}
/deep/ .el-pagination__total,
/deep/.el-pagination__jump {
  color: #bac7d5;
}
.el-pagination {
  /deep/ .el-pagination__editor.el-input,
  /deep/.el-input__inner {
    width: auto;
  }
}
.title {
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #08396a;
  display: flex;
  align-items: center;
  margin-left: 20px;

  img {
    width: 14px;
    height: 14px;
  }

  span {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #dfecf7;
    padding-left: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataList2.vue